import { isFunction } from './is';
export const getRenderPropValue = (propValue) => {
    if (!propValue) {
        return null;
    }
    return isFunction(propValue) ? propValue() : propValue;
};
